import React, { Component } from 'react';
import { withStyles, Grid, Table, TableHead, TableBody, TableCell, TableRow, Typography } from '@material-ui/core';
import styles from './styles/DailyProcessInfoStyles';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    position: 'sticky',
    top: 0
  },
  body: {
    backgroundColor: theme.palette.common.white,
    fontSize: 14
  }
}))(TableCell);

class DailyProcessInfo extends Component {
  render() {
    const { classes, dailyInfo } = this.props;
    if (dailyInfo && dailyInfo.length > 0) {
      return (
        <div>
          <Typography variant="title" className={classes.tableTitle} id="tableTitle">Informações Diárias de Processamento</Typography>
          <Grid className={classes.root}>
            <Table>
              <TableHead>
                <TableRow>
                  <CustomTableCell>Início</CustomTableCell>
                  <CustomTableCell>Fim</CustomTableCell>
                  <CustomTableCell>Coordenadas Processadas</CustomTableCell>
                  <CustomTableCell>Resultados Gerados</CustomTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dailyInfo.map((info, key) => {
                  const dateStart = new Date(info.start).toLocaleDateString('pt');
                  const dateEnd = new Date(info.end).toLocaleDateString('pt');
                  const timeStart = new Date(info.start).toLocaleTimeString();
                  const timeEnd = new Date(info.end).toLocaleTimeString();
                  return (
                    <TableRow key={key}>
                      <CustomTableCell>{dateStart + ' ' + timeStart}</CustomTableCell>
                      <CustomTableCell>{dateEnd + ' ' + timeEnd}</CustomTableCell>
                      <CustomTableCell>{info.totalProcessedCoordinates}</CustomTableCell>
                      <CustomTableCell>{info.resultAmount}</CustomTableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </div>
      );  
    }
    
    return null;
  }
}

export default withStyles(styles)(DailyProcessInfo);


// WEBPACK FOOTER //
// ./src/main/components/DailyProcessInfo.jsx